<template>
  <UnauthorizedBlock>
    <div class="text-xl text-text font-bold text-center mb-20 -mt-1">
      {{ $t('title') }}
    </div>
    <div class="text-md text-text font-bold text-center mb-12 leading-8">
      {{ $t('subtitle') }}
    </div>
    <CreateSpaceForm/>
  </UnauthorizedBlock>
</template>

<script>
import UnauthorizedBlock from "@/components/layouts/common/UnauthorizedBlock";
import CreateSpaceForm from "@/components/common/CreateSpaceForm/CreateSpaceForm";

export default {
  name: "CreateAccounting",
  components: {
    CreateSpaceForm,
    UnauthorizedBlock,
  },
  i18n: {
    messages: {
      en: {
        title: 'Welcome to Moneykeeper',
        subtitle: 'Create your own workspace in a couple of clicks.'
      },
      ru: {
        title: 'Добро пожаловать в Moneykeeper',
        subtitle: 'Создайте своё пространство в пару кликов.'
      }
    }
  }
}
</script>
